import { Html5QrcodeScanner } from "html5-qrcode";
import { useEffect, useState } from "react";
import { BASE_API } from '../../api/Globals';
import { helpHttp } from '../../helpers/helpHttp';

const ScannerFiltro = ({ carga }) => {

    const [scanResult, setScanResult] = useState(null);

    useEffect(() => {
        const scanner = new Html5QrcodeScanner('reader', {
            qrbox: {
                width:300,
                height: 300,
            },
            fps: 5
        });

        scanner.render(success, error);

        function success(result) {
            scanner.clear();
            setScanResult(result);

            carga(result);

            console.log();
        }

        function error(err) {
            //console.warn(err);
        }
    }, []);

    return (
        <>
            { scanResult
            ? <div>Success: <div>{scanResult}</div></div>
            : <div id="reader"></div>
            }
        </>
    );
};

export default ScannerFiltro;